import { UIKitButton } from './UIKitButton';
import { IComponentDefinition } from '../../../grapesJs/reactComponentsRegistry/types';
import { COMMON_COMPONENT_PROPS } from '../../../grapesJs/reactComponentsRegistry/const';

export const uiKitButtonComponent: IComponentDefinition = {
  ...COMMON_COMPONENT_PROPS,
  id: 'uiKitButton',
  component: UIKitButton,
  tagName: 'uikitbutton',
  stylable: true,
  droppable: false,
  defaultAttributes: {
    action: '',
    category: '',
    label: '',
    theme: 'fill_primary',
    size: 'M',
    fullWidth: false,
  },
  traits: [
    {
      type: 'text',
      label: 'CA action',
      name: 'action',
    },
    {
      type: 'text',
      label: 'CA category',
      name: 'category',
    },
    {
      type: 'text',
      label: 'CA label',
      name: 'label',
    },
    {
      type: 'select',
      label: 'Button size',
      name: 'size',
      default: 'M',
      options: [
        { id: 'L', value: 'L', name: 'L' },
        { id: 'M', value: 'M', name: 'M' },
        { id: 'XS', value: 'XS', name: 'XS' },
      ],
    },
    {
      type: 'text',
      label: 'Theme',
      name: 'theme',
    },
    {
      type: 'checkbox',
      label: 'Full width',
      name: 'fullWidth',
    },
  ],
  block: {
    label: 'Button',
    category: 'UI Components',
    content: `
        <UIKitButton>Нажми меня</UIKitButton>
      `,
  },
};
